<input class="ng-valid form-control" type="text" placeholder="Ricerca comune"
  (change)="updateSearch($event.target.value)">

<select (change)="customChange(selector.value)" class="form-control ng-valid mt-2" #selector>
  <option [value]="c?.codice_comune" *ngFor="let c of comuni | async">
    {{c?.nome}}
  </option>
</select>